import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchRTRWithdrawTransaction from '@/hooks/useApi/useFetchRTRWithdrawTransaction';
import VopayInstantWithdrawalInfo from './VopayInstantWithdrawalInfo';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type TransactionProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof VopayInstantWithdrawalInfo>, 'transaction'>;

export default function VopayInstantWithdrawalContainer({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
  ELinxRequestID = '',
  ...props
}: TransactionProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { rtrWithdrawTransaction, fetchRTRWithdrawTransaction } = useFetchRTRWithdrawTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchRTRWithdrawTransaction(TransactionID)
      .catch((error) =>
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred')),
      )
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = rtrWithdrawTransaction;

  return (
    <div>
      {transaction && (
        <VopayInstantWithdrawalInfo
          transaction={transaction}
          Notes={Notes}
          isParent={isParent}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
